import { typeValuesListItem } from "components/UI/SelectBox/SelectBox";

export const vatAllowedValue = {
  "0%": 0,
  "12%": 0.12,
};

export const vatList: typeValuesListItem[] = [
  { id: vatAllowedValue["0%"], name: "0 %" },
  { id: vatAllowedValue["12%"], name: "12 %" },
];

export const getVatAllowedValue = (value: number) => {
  switch (value) {
    case 0:
      return vatAllowedValue["0%"];
    case 12:
      return vatAllowedValue["12%"];
    default:
      return vatAllowedValue["0%"];
  }
};
